<div></div>

<div class="ui info message">
    <div class="header">
        List of Active Agencies
    </div>
    <p>Clicking on a link below will display the live, real-time activity ocurring at that emergency dispatch center.</p>
    <p>
        <strong>You do not need to refresh</strong> the active call listings that appear on the pages. The call information will
        update automatically.</p>
</div>

<div *ngIf="!db_read_complete">
    <div class="ui active inverted dimmer">
        <div class="ui large text loader">Loading Event Data ...</div>
    </div>
</div>

<div *ngIf="db_read_complete" class="ui big relaxed divided list">
    <ng-template ngFor let-api_client of [ngForOf]="api_clients">
        <div *ngIf="api_client.parent_agency_id === api_client.agency_id" class="item">
            <div *ngIf="api_client.disabled === true">
                <div class="header">{{api_client.name}} (Access Restricted)</div>
            </div>
            <div *ngIf="api_client.disabled !== true">
                <div class="header">
                    <a [href]="'/agency/' + api_client.parent_agency_id" [routerLink]="'/agency/' + api_client.parent_agency_id">
                        {{api_client.name}}
                    </a>
                    <a [href]="'/agency/' + api_client.parent_agency_id" [routerLink]="'/agency/' + api_client.parent_agency_id">
                        <button class="ui primary small compact button view-events">View Calls</button>
                    </a>
                    <button *ngIf="api_client.child_agencies > 1" class="ui primary small compact button" (click)="show_child_agencies[api_client.parent_agency_id] = !show_child_agencies[api_client.parent_agency_id]">
                        <span>{{api_client.child_agencies}} Agencies</span>
                    </button>
                </div>

                <div *ngIf="show_child_agencies[api_client.parent_agency_id]">
                    <ng-template ngFor let-api_client_child of [ngForOf]="api_clients">
                        <div *ngIf="api_client_child.parent_agency_id === api_client.agency_id" class="item">
                            <div class="child-header">
                                {{api_client_child.name}}
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </ng-template>
</div>


// WEBPACK FOOTER //
// ./src/app/components/agencies/agencies.component.html